<template>
  <div class="datepicker-wrapper">
    <date-picker
      :value="value"
      type="date"
      :format="format"
      :placeholder="placeholder"
      :disabled="disabled"
      :input-class="inputClass"
      v-bind="disabledDate ? { 'disabled-date': disabledDate } : {}"
      @open="repositionPopup"
      @input="$emit('input', $event)"
    ></date-picker>
    <svg
      v-if="isError && showErrorIcon"
      class="datepicker-invalid-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#dc3545"
      stroke-width="2"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="13" />
      <circle cx="12" cy="16.5" r="0.5" fill="#dc3545" stroke="none" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "DatePickerField",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      default: null,
    },
    format: {
      type: String,
      default: "DD MMM YY",
    },
    placeholder: {
      type: String,
      default: "วว/ดด/ปป",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    showErrorIcon: {
      type: Boolean,
      default: true,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    disabledDate: {
      type: Function,
      default: null,
    },
  },
  computed: {
    inputClass() {
      const classes = ["form-control", "d-block"];
      if (this.isRequired) classes.push("required");
      if (this.isError) classes.push("is-invalid");
      return classes.join(" ");
    },
  },
  methods: {
    repositionPopup() {
      this.$nextTick(() => {
        const wrapper = this.$el;
        const input = wrapper.querySelector("input");
        const popup = document.querySelector(".mx-datepicker-main");
        if (!input || !popup) return;
        const rect = input.getBoundingClientRect();
        popup.style.position = "fixed";
        popup.style.top = rect.bottom + window.scrollY + "px";
        popup.style.left = rect.left + window.scrollX + "px";
      });
    },
  },
};
</script>

<style scoped>
.datepicker-wrapper {
  position: relative;
  width: 100%;
}

.datepicker-invalid-icon {
  position: absolute;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;
  width: 20px;
  height: 20px;
}

::v-deep .mx-datepicker {
  width: 100%;
}


::v-deep .form-control.is-invalid {
  background-image: none !important;
}

::v-deep .form-control.required {
  background-color: #ccecff6c;
}

::v-deep .form-control.required:disabled {
  background-color: #e9ecef;
}
</style>
